import { BaseModel } from './Base';
import { ID } from './Firebase';
import { Parcel } from './Cabify';

export type TripType = 'one_way' | 'round_trip';

export type Shipment = BaseModel & {
    trip_type: TripType;
    order_id: ID;
    pharmacy_id: ID;
    courier: 'cabify';
    estimate: Estimate;
    round_trip: boolean; // legacy, borrar eventualmente
    state: DeliveryState;
    parcels: Parcel[];
};

export type Estimate = {
    // price in cents without tip
    original_price: number;
    // tip in cents
    tip: number;
    // price in cents plus tip
    price: number;
    // time in seconds
    eta_to_pick_up: number;
    // time in seconds. Can also be -1 for unknown time
    eta_to_delivery: number;
};

export type OkState =
    // Basado en estado de Cabify, pero se le agregó algunos más.
    // Estado inicial
    | 'estimated'
    // camino feliz
    | 'requested'
    | 'on_route_to_pickup'
    | 'at_pickup'
    | 'on_route_to_dropoff'
    | 'at_dropoff'
    | 'delivered_at_dropoff'
    // casos para el retorno de la receta.
    | 'returning_to_pickup'
    | 'returned_to_pickup'
    | 'delivered_at_pickup'
    | 'archived' // caso final camino feliz
    // casos de cancelación
    | 'internal_cancel';

export type DeliveryState = OkState | ErrorState;
export const errorStates = [
    'returning',
    'returned',
    'incident',
    'courier_canceled',
    'pickup_failed',
] as const;

export type ErrorState = (typeof errorStates)[number];

export const unconfirmed = (delivery: Shipment) =>
    ['estimated', 'requested'].includes(delivery.state);
export const headingToDropOff = (delivery: Shipment) =>
    ['on_route_to_dropoff', 'at_dropoff', 'delivered_at_dropoff'].includes(delivery.state);
export const headingToStore = (delivery: Shipment) =>
    ['on_route_to_pickup', 'returning_to_pickup'].includes(delivery.state);
export const atStore = (delivery: Shipment) =>
    // Queremos llamar la atención del usuario cuando el delivery está en la puerta del local o cuando está cerca
    ['at_pickup', 'returned_to_pickup'].includes(delivery.state);
